var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBoxplotMin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 12L0.625 12C0.278646 12 0 11.7206 0 11.3734V10.7467C0 10.3994 0.278646 10.1201 0.625 10.1201L9.375 10.1201C9.72135 10.1201 10 10.3994 10 10.7467V11.3734C10 11.7206 9.72135 12 9.375 12ZM3.33333 0.929276L3.33333 4.48026H1.04948C0.585938 4.48026 0.354167 5.04163 0.682292 5.37062L4.64323 9.34459C4.83854 9.54042 5.15885 9.54042 5.35417 9.34459L9.32031 5.37062C9.64844 5.04163 9.41406 4.48026 8.95052 4.48026H6.66667L6.66667 0.929276C6.66667 0.582009 6.38802 0.30263 6.04167 0.30263H3.95833C3.61198 0.30263 3.33333 0.582009 3.33333 0.929276Z",
    fill: "#1E88E5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxplotMin);
export default __webpack_public_path__ + "static/media/icon_boxplot_min.e1c18b7a51a378e68335e9d74fd1f126.svg";
export { ForwardRef as ReactComponent };